import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.CommunicationPane.title',
    defaultMessage: 'Communication Pane',
  },
})
